(() => {
  // Progressive enhancement: content remains visible if animations are unavailable.
  const main = document.querySelector('main');
  if (!main || !('IntersectionObserver' in window) || !Element.prototype.animate) return;

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Map();
  const targets = [
    ['#shopify-section-jhp-awards .awards-header'],
    ['#shopify-section-jhp-awards .awards-list'],
    ['#shopify-section-services-tiles > section > .text-center'],
    ['#shopify-section-services-tiles .grid > div', true],
    ['#shopify-section-live_shows_banner .grid > div', true],
    ['#shopify-section-intro-video .grid > div', true],
    ['#shopify-section-homepage-reviews .home-flow-heading'],
    ['#shopify-section-homepage-reviews .home-review', true],
    ['#shopify-section-homepage-reviews .home-reviews-actions'],
    ['#shopify-section-homepage-books .home-flow-heading'],
    ['#shopify-section-homepage-books .home-book', true],
    ['#shopify-section-jh-blog-grid .jh-blog-featured'],
    ['#shopify-section-jh-blog-grid .jh-blog-card-h', true],
    ['#shopify-section-homepage-booking .home-booking-inner']
  ];

  const reveal = (element, immediate = false) => {
    if (seen.has(element)) return;
    seen.add(element);
    observer.unobserve(element);
    if (immediate || motion.matches) return;
    const animation = element.animate([
      { opacity: 0, translate: window.innerWidth >= 768 ? '0 64px' : '0 44px' },
      { opacity: 1, translate: '0 0' }
    ], {
      duration: 1050,
      delay: window.innerWidth >= 768 ? Number(element.dataset.revealDelay || 0) : 0,
      easing: 'cubic-bezier(0.2, 0.65, 0.3, 1)',
      fill: 'backwards'
    });
    active.set(element, animation);
    animation.onfinish = animation.oncancel = () => active.delete(element);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) reveal(target);
    });
  }, { threshold: 0, rootMargin: '0px' });

  const register = () => {
    targets.forEach(([selector, stagger]) => {
      document.querySelectorAll(selector).forEach((element, index) => {
        if (!main.contains(element) || seen.has(element)) return;
        element.dataset.revealDelay = stagger ? String((index % 4) * 110) : '0';
        const rect = element.getBoundingClientRect();
        // Never hide content already in view, including restored scroll positions.
        if (rect.top < window.innerHeight && rect.bottom > 0) reveal(element, true);
        else observer.observe(element);
      });
    });
  };

  // Keyboard users get the focused content immediately, without waiting for a fade.
  main.addEventListener('focusin', (event) => {
    let element = event.target;
    while (element && element !== main) {
      if (element.dataset.revealDelay !== undefined) {
        reveal(element, true);
        active.get(element)?.cancel();
      }
      element = element.parentElement;
    }
  });
  motion.addEventListener('change', () => {
    if (motion.matches) active.forEach((animation) => animation.cancel());
  });
  document.addEventListener('shopify:section:load', register);
  document.addEventListener('google-reviews-loaded', register);
  register();
})();
